const APP_BARS_HIDDEN_DATASET_KEY = 'appBarsHidden';

export const areAppBarsHidden = (): boolean => {
  return (
    document.documentElement.dataset[APP_BARS_HIDDEN_DATASET_KEY] === 'true'
  );
};

export const setAppBarsHidden = (isHidden: boolean): void => {
  const root = document.documentElement;
  if (isHidden) {
    root.dataset[APP_BARS_HIDDEN_DATASET_KEY] = 'true';
    root.style.setProperty('--app-sidebar-width', '0px');
    root.style.setProperty('--app-sidebar-collapsed-width', '0px');
    root.style.setProperty('--app-header-height', '0px');
    root.style.setProperty('--app-header-min-height', '0px');
    root.style.setProperty('--app-header-max-height', '0px');
    root.style.setProperty('--app-header-overflow', 'hidden');
    return;
  }

  root.dataset[APP_BARS_HIDDEN_DATASET_KEY] = 'false';
  root.style.removeProperty('--app-sidebar-width');
  root.style.removeProperty('--app-sidebar-collapsed-width');
  root.style.removeProperty('--app-header-height');
  root.style.removeProperty('--app-header-min-height');
  root.style.removeProperty('--app-header-max-height');
  root.style.removeProperty('--app-header-overflow');
};

export const toggleAppBarsHidden = (): boolean => {
  const nextIsHidden = !areAppBarsHidden();
  setAppBarsHidden(nextIsHidden);
  return nextIsHidden;
};

export const restoreAppBars = (): boolean => {
  if (!areAppBarsHidden()) {
    return false;
  }
  setAppBarsHidden(false);
  return true;
};
